import React from 'react'
import ImgBack from '../../images/back.webp'
import './postCardBack.scss'

const PostCardBack = () => {
  return <img className="PostCardBack" src={ImgBack} alt="69 W Elm St, Hopkinton MA,01748" />
}

export default PostCardBack
